<template>
	<div id="applicants">
		<h1><i class="fad fa-file-user fa-fw"></i> Applicants</h1>
		<div v-if="isLoading"><i class="fad fa-spinner-third fa-spin fa-2x"></i></div>
		<div v-else id="applicant-container" class="rec-container">
			<router-link v-bind:to="'/admin/applicant/profile/' + applicant.id" class="rec" v-for="applicant in applicantList" v-bind:key="applicant.id">
				<div>
					<div>
						<span>{{applicant.nameFirst}} {{applicant.nameLast}}</span> <span class="info">({{age(applicant.dob)}}yrs old)</span>
					</div>
					<div>
						<strong class="info">
							{{daysOld(applicant.dateCreated.seconds)}}
						</strong>
					</div>
				</div>
				<div class="status-bar">
					<div class="status" v-bind:class="applicant.status">
						{{applicant.status}}
					</div>
				</div>
			</router-link>
		</div>
	</div>
</template>
<script>
const dayjs = require('dayjs')
export default {
	data() {
		return {
			isLoading: false
		};
	},
	computed: {
		applicantList(){
			return this.$store.getters.applicantsAlpha
		}
	},
	methods: {
		async loadApplicants() {
			this.isLoading = true
			await this.$store.dispatch('loadApplicants')
			setTimeout(()=>{ 
				this.isLoading = false
			},150)
		},
		age(dob){
			if(dob){
				let date_dob = dayjs(dob)
				let date_now = dayjs()
				return date_now.diff(date_dob,'year')
			} else {
				return ''
			}
		},
		daysOld(date){
			if(date){
				let date_created = dayjs.unix(date).format('YYYY-MM-DD')
				let date_now = dayjs()
				let days = date_now.diff(date_created,'day')
				if(days <= 1){
					return days + ' day ago'
				} else {
					return days + ' days ago'
				}
			} else {
				return ''
			}
		}
	},
	created() {
		if( this.applicantList.length <= 1){
			this.loadApplicants()
		}
	}
}
</script>
<style scoped>
.rec-container a {
	flex-direction: column;
}

.rec-container a > div {
	display: flex;
	justify-content: space-between;
	width: 100%;
}
</style>